'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _query = require('utilities/query');

var _products = require('./products.service');

var _products2 = _interopRequireDefault(_products);

var _products3 = require('./products.component');

var _products4 = _interopRequireDefault(_products3);

var _productSearch = require('./product-search/product-search.module');

var _productSearch2 = _interopRequireDefault(_productSearch);

var _productLabelPreview = require('./product-label-preview/product-label-preview.module');

var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);

require('./products.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.products', [_angularUiRouter2.default, _productLabelPreview2.default, _productSearch2.default]).component('products', _products4.default).service('ProductsService', _products2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('products', {
    parent: 'app',
    url: '/products',
    component: 'products',
    data: {
      permissions: {
        except: [_roles.REGULATOR],
        redirectTo: 'app'
      }
    },
    params: {
      search: {
        value: 'default'
      }
    },
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      user: function user(currentUser) {
        return currentUser;
      },
      query: function query() {
        return (0, _query.getQuery)();
      },
      limitOptions: function limitOptions() {
        return (0, _query.getLimitOptions)();
      },
      alerts: function alerts(ProductsService) {
        return ProductsService.getAlerts().then(function (r) {
          return r.data;
        });
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      products: function products($stateParams, query, ProductsService) {
        ProductsService.setQuery(query);

        if (!$stateParams.search) {
          return ProductsService.getProducts().then(function (r) {
            return r.data;
          });
        }

        if ($stateParams.search === 'missing_sales') {
          return ProductsService.getProductsMissingSalesData().then(function (r) {
            return r.data;
          });
        } else if ($stateParams.search === 'missing_info') {
          return ProductsService.getProductsMissingProductInfo().then(function (r) {
            return r.data;
          });
        }

        return ProductsService.getProducts().then(function (r) {
          return r.data;
        });
      },
      // TODO: Refactor to OData call
      categories: function categories(ProductService) {
        return ProductService.getCategories().then(function (r) {
          return r.data;
        });
      },
      administrationUnits: function administrationUnits(ProductService) {
        return ProductService.getAdministrationUnits().then(function (r) {
          return r.data;
        });
      },
      searchCriteria: function searchCriteria($stateParams) {
        var selectedSearchType = 'All Products';
        if ($stateParams.search === 'missing_sales') {
          selectedSearchType = 'Missing - Containers Shipped Data';
        } else if ($stateParams.search === 'missing_info') {
          selectedSearchType = 'Missing - Product Information';
        }

        return {
          selectedSearchType: selectedSearchType
        };
      },
      searchTypes: function searchTypes(ProductsService) {
        return ProductsService.getSearchTypes();
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/products/products.module.js